import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { map, isUndefined } from "lodash";
import { withBem } from "../hocs";
import { Row, Col } from "../components/layout";
import LinkWithArrow from "./link-with-arrow";
import Fade from "react-reveal/Fade";

const Project = ({
  project,
  cn,
  className,
  altImage,
  homeCarousel = false,
  withFade = true,
  ...rest
}) => {
  const renderProject = () => (
    <Fragment>
      <div className={(!project.internal || homeCarousel) && cn("info")}>
        <div className={cn("title-block")}>
          <h3 className={cn("title")}>{project.title}</h3>
          <div className={cn("details")}>
            {!isUndefined(project.platformsExcerpt) && (
              <div className={cn("inline-field")}>
                <span>Platform</span>
                <span>{project.platformsExcerpt}</span>
              </div>
            )}

            <div className={cn("inline-field")}>
              <span>Year</span>
              <span>{project.year}</span>
            </div>
          </div>
        </div>

        <div
          className={(!project.internal || homeCarousel) && cn("intro-block")}
        >
          <div className={cn("introduction")}>{project.introduction}</div>
          {!project.internal ? (
            <LinkWithArrow
              to={"/our-work/" + project.id}
              className={cn("link")}
            >
              View project
            </LinkWithArrow>
          ) : (
            <LinkWithArrow href={project.externalLink} className={cn("link")}>
              {homeCarousel ? "View project" : "View more"}
            </LinkWithArrow>
          )}
        </div>
      </div>

      {!project.internal && (
        <div className={cn("image-wrapper")}>
          <Link
            to={`/our-work/${project.id}`}
            title={project.id}
            className={cn("link")}
          >
            <img
              className={cn("image")}
              src={
                homeCarousel
                  ? project.homepage_image.url
                  : project.featured_image.url
              }
              title={project["images"][0]["name"]}
            />
          </Link>
        </div>
      )}
      {project.internal && (
        <div
          className={cn(`${homeCarousel ? "image-wrapper" : "logo-wrapper"}`)}
        >
          <a href={project.externalLink}>
            <img
              className={cn("image")}
              src={
                homeCarousel
                  ? project.homepage_image.url
                  : project["hero_images"][0]["url"]
              }
              title={
                homeCarousel
                  ? project.homepage_image.urls
                  : project["hero_images"][0]["name"]
              }
            />
          </a>
        </div>
      )}
    </Fragment>
  );

  return (
    <div {...rest} className={classnames(cn(), className)}>
      {withFade ? <Fade delay={200}>{renderProject()}</Fade> : renderProject()}
    </div>
  );
};
Project.propTypes = {
  project: PropTypes.object.isRequired
};

export default withBem("project")(Project);
